module.exports = __webpack_public_path__ + "static/media/bungalow3.899c0f81.jpg";